module.exports = __webpack_public_path__ + "img/Picture14.f2c68322.jpg";